module.exports = __webpack_public_path__ + "img/kv2_sp.a6013545.jpg";